// eslint-disable-next-line import/prefer-default-export
export const NOTIFICATION_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
};
